<template>
    <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        @keydown.prevent.enter="submit"
    >
        <TextFieldWithValidation
            v-model="email"
            type="text"
            auto-focus
            :label="$t('email')"
            name="email"
            autocomplete="email"
            placeholder="email@domain.com"
            rules="required|email"
        />
        <TextFieldWithValidation
            v-model="password"
            type="password"
            autocomplete="current-password"
            :label="$t('password')"
            name="password"
            placeholder="**********"
            rules="required"
        />
        <div class="flex items-center justify-between">
            <AntButton
                type="primary"
                :disabled="invalid || !validationObserverReady"
                :loading="loader.isLoading"
                @click="submit"
            >
                {{ $t('login') }}
            </AntButton>
            <span class="text-gray-700">
                <RouterLink :to="{ name: 'forgotPassword' }">
                    {{ $t('forgotPassword') }}
                </RouterLink>
            </span>
        </div>
    </ValidationObserver>
</template>

<script>
import validationObserverMixin from '@/mixins/validationObserver';
import TextFieldWithValidation from '@/components/forms/elements/withValidation/TextFieldWithValidation.vue';
import { Button } from 'ant-design-vue';
import { mapGetters } from 'vuex';
import { DelayLoader } from '@/helpers';

export default {
    name: 'Login',
    components: {
        AntButton: Button,
        TextFieldWithValidation,
    },
    mixins: [validationObserverMixin],
    data() {
        return {
            email: '',
            password: '',
            loader: new DelayLoader(),
        };
    },
    computed: {
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
        }),
    },
    created() {
        if (this.isAuthenticated) {
            this.navigate();
        }
    },
    methods: {
        async submit() {
            if (this.loader.isProcessing || !await this.$refs.observer.validate()) {
                return;
            }

            this.loader.start();

            const { email, password } = this.$data;

            this.$store
                .dispatch('auth/authenticate', {
                    email,
                    password,
                })
                .then(this.navigate)
                .catch(errors => {
                    this.password = '';
                    this.$notification.error({ message: this.$t('incorrectCredentials') });
                })
                .finally(() => this.loader.reset());
        },
        navigate() {
            this.$router.push({ name: 'measures' });
        },
    },
};
</script>
